import './footer.css';
import { Link } from 'react-router-dom';

import { useNavigate, useSearchParams } from 'react-router-dom';

import Button from '../../components/button/button';
import ExpensibleLogo from '../../assets/expensibleLogo/expensibleLogo';
import SpaceBar from '../../components/spacerBars/spaceBar';

export default function Footer({isMobile, scrollNavigation}) {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    };

    const navigate = useNavigate();

    const startButton = () => {
        navigate('/sign_up'); 
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
            });
    };

    return(
        <footer className="footer">
            <div className="footer-container">
                
                <div className="footer-top">
                    <div className="footer-top-a">
                        <h3>Links</h3>
                        <SpaceBar width={isMobile ? '40%' : '60%'} thick={true} color={'var(--background-color)'} offset={isMobile ? '-4rem' : '-1rem'}/>
                        <Link to="/"><p onClick={scrollToTop}>Home</p></Link>
                        <Link to="/portfolio"><p onClick={scrollToTop}>Portfolio</p></Link>
                        <Link to="/contact"><p onClick={scrollToTop}>Contact</p></Link>
                    </div>
                    <div className="footer-top-b">
                        <h3>Follow us!</h3>
                        <SpaceBar width={'60%'} thick={true} color={'var(--background-color)'} offset={isMobile ? '-4rem' : '-1rem'}/>
                        <p>Facebook</p>
                        <p>Instagram</p>
                        <p>Linkdin</p>
                    </div>
                    <div className="footer-top-c">
                        <h3>Customer Mission</h3>
                        <SpaceBar width={isMobile ? '88%' : '60%'} thick={true} color={'var(--background-color)'} offset={isMobile ? '-4rem' : '-1rem'}/>
                        <p>Empower every business to simplify spending, reclaim time, and make smarter financial decisions — with secure, easy-to-use expense tools that scale from one person to thousands.</p>
                    </div>
                    <div></div>
                    <div className="footer-top-d">
                        <h3>Get started Expensing!</h3>
                        <SpaceBar width={isMobile ? '106%' : '60%'} thick={true} color={'var(--background-color)'} offset={isMobile ? '-4rem' : '-1rem'}/>
                        <p>Sign up and start expensible today for your bussiness finanical needs!! </p>
                        <Button buttonName="Start!" onClick={startButton}/>
                    </div>
                </div>

                {isMobile ? 
                
                <div className="footer-bottom">
                    <div className="footer-copright">
                        <ExpensibleLogo/>
                    </div>
                    <div className="footer-terms">
                        <p>&copy; Micalister Pilgrim 2026</p>
                        <p>||</p>
                        <p>Terms and Conditions</p>
                    </div>
                </div> 
                
                : 
                
                <div className="footer-bottom">
                    <div className="footer-copright">
                        <ExpensibleLogo/>
                        <p>&copy; Micalister Pilgrim 2026</p>
                    </div>
                    <div className="footer-terms">
                        <p>Terms and Conditions</p>
                    </div>
                </div>

                }
                

            </div>
        </footer>
    )
}